import * as React from "react";
import { Playground } from "../Playground";
import { BaseballHeaderItem } from "../BaseballHeaderItem";
export function PlaygroundWrapper(props) {
    return (React.createElement("div", { className: "rj-sport-scoreboard__playground-wrapper" },
        React.createElement("div", { className: "rj-sport-scoreboard__playground-header" }, props.header.map((text, index) => React.createElement(BaseballHeaderItem, Object.assign({}, { text, index }, { key: `baseball-playground-header-item-${index}` })))),
        React.createElement("div", { className: "rj-sport-scoreboard__playground-body" },
            React.createElement(Playground, { base: props.base }))));
}
//# sourceMappingURL=PlaygroundWrapper.js.map